import { ref, computed } from 'vue';

/**
 * Shared date-range filter state and logic for report views.
 * @param {import('vue').ComputedRef<Array>} sessionlist - reactive session list to filter
 */
export function useDateFilter(sessionlist) {
  const dateMode = ref('all');
  const fromDate = ref(new Date(2019, 8, 1));
  const toDate   = ref(new Date());
  const fromDateMenu = ref(false);
  const toDateMenu   = ref(false);

  function setAllTime() {
    const list = sessionlist.value;
    if (!list?.length) return;
    const sorted = [...list]
      .filter(s => s.sessiondate)
      .sort((a, b) => new Date(a.sessiondate) - new Date(b.sessiondate));
    fromDate.value = sorted[0]?.sessiondate ? new Date(sorted[0].sessiondate) : new Date(2019, 8, 1);
    toDate.value   = sorted[sorted.length - 1]?.sessiondate ? new Date(sorted[sorted.length - 1].sessiondate) : new Date();
    dateMode.value = 'all';
  }

  function setYearToDate() {
    const now = new Date();
    fromDate.value = new Date(now.getFullYear(), 0, 1);
    toDate.value   = new Date();
    dateMode.value = 'ytd';
  }

  function setLast12Months() {
    const now = new Date();
    fromDate.value = new Date(now.getFullYear(), now.getMonth() - 11, 1);
    toDate.value   = new Date();
    dateMode.value = 'last12';
  }

  function setCustom() {
    dateMode.value = 'custom';
  }

  function formatDate(date) {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  function parseDate(val) {
    if (!val) return null;
    return new Date(val + 'T00:00:00');
  }

  const filteredSessions = computed(() => {
    const list = sessionlist.value;
    if (!list?.length) return [];
    const from = new Date(fromDate.value);
    const to   = new Date(toDate.value);
    from.setHours(0, 0, 0, 0);
    to.setHours(23, 59, 59, 999);
    return list.filter(s => {
      if (!s.sessiondate) return false;
      const d = s.sessiondate instanceof Date ? s.sessiondate : new Date(s.sessiondate);
      return d >= from && d <= to;
    });
  });

  return {
    dateMode, fromDate, toDate, fromDateMenu, toDateMenu,
    filteredSessions,
    setAllTime, setYearToDate, setLast12Months, setCustom,
    formatDate, parseDate,
  };
}
